import { Typography } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import CustomPagination from "../../../constants/CustomPagination";
import { useSelector } from "react-redux";
import { translateNews } from "../network_requests";

export default function News(props) {
  const { data } = props;
  const [page, setPage] = useState(1);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);
  const stoqqyLang = window.localStorage.getItem("stoqqyLang");

  return (
    <div
      style={{
        display: "flex",
        padding: isDesktopOrLaptop
          ? "30px 98px 0px 341px"
          : "0px 11px 0px 10px",
      }}
    >
      <Grid
        style={{
          width: isDesktopOrLaptop ? "100%" : "85vw",
        }}
      >
        {data?.slice((page - 1) * 10, page * 10)?.map((news) => {
          return <NewsCard news={news} />;
        })}
        <div style={{ width: isDesktopOrLaptop ? "757px" : "95vw" }}>
          <CustomPagination
            page={page}
            totalPages={Math.ceil(data?.length / 10)}
            setPage={setPage}
            margin="40px"
            marginBottom="30px"
          />
        </div>
      </Grid>
    </div>
  );
}

const NewsCard = (props) => {
  const news = props.news;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const [translate, setTranslate] = useState(false);
  const [newContent, setNewContent] = useState("");
  const [newTitle, setNewTitle] = useState("");
  const [imageError, setImageError] = useState(false);

  const stoqqyLang = window.localStorage.getItem("stoqqyLang");

  useEffect(() => {
    setTranslate(false);
    setNewContent("");
    setNewTitle("");
  }, [news]);

  // useEffect(async () => {
  //   if (stoqqyLang === "it") {
  //     setLoad(true);
  //     const newTitle_ = await translateNews(news.title);
  //     const newContent_ = await translateNews(news.content);
  //     setNewTitle(newTitle_);
  //     setNewContent(newContent_);
  //     setTranslate(!translate);
  //     setLoad(false);
  //   }
  // }, [stoqqyLang]);

  return (
    <>
      <div
        style={{
          borderRadius: "20px",
          width: isDesktopOrLaptop ? "757px" : "100%",
          border: "solid 1px #979797",
          display: isDesktopOrLaptop ? "flex" : "",
          marginBottom: "25px",
          padding: isDesktopOrLaptop ? "" : "17px 14px 17px 14px",
        }}
      >
        <>
          {isDesktopOrLaptop ? null : imageError ? (
            <div></div>
          ) : (
            <img
              style={{
                width: "100%",
                borderRadius: "25px",
              }}
              src={news?.urlToImage}
              onError={(e) => {
                setImageError(true);
              }}
            ></img>
          )}
          <Grid
            style={{
              padding: isDesktopOrLaptop ? "24px 61px 23px 22px" : "21px 0 0 0",
            }}
            item
            xs={isDesktopOrLaptop ? 9 : 12}
          >
            <div style={{ display: "flex", width: "100%" }}>
              <Grid item xs={news?.English ? 12 : 5}>
                <Typography
                  style={{
                    fontFamily: "Overpass",
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#0040ff",
                  }}
                >
                  {news?.source?.name}
                </Typography>
              </Grid>
              {(news?.English && stoqqyLang === "en") ||
              (news?.Italain && stoqqyLang === "it") ||
              (news?.German && stoqqyLang === "de") ||
              (news?.Spanish && stoqqyLang === "es") ||
              (news?.French && stoqqyLang === "fr") ? null : (
                <Grid
                  item
                  xs={7}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Typography
                    style={{
                      fontFamily: "Overpass",
                      fontSize: "14px",
                      color: "#0040ff",
                      textDecoration: "underline",
                      paddingRight: isDesktopOrLaptop ? "20px" : 0,
                      cursor: "pointer",
                    }}
                    onClick={async () => {
                      if (newTitle === "" || newContent === "") {
                        const newTitle_ = await translateNews(news.title);
                        const newContent_ = await translateNews(news.content);
                        setNewTitle(newTitle_);
                        setNewContent(newContent_);
                      }
                      setTranslate(!translate);
                    }}
                  >
                    {translate
                      ? "Read original"
                      : `Translate to ${
                          stoqqyLang === "it"
                            ? "Italian"
                            : stoqqyLang === "es"
                            ? "Spanish"
                            : stoqqyLang === "fr"
                            ? "French"
                            : stoqqyLang === "de"
                            ? "German"
                            : "English"
                        }`}
                  </Typography>
                </Grid>
              )}
            </div>

            <a
              href={news?.url}
              target="_blank"
              style={{
                textDecoration: "none",
                marginTop: "4px",
                fontFamily: "Overpass",
                fontSize: "21px",
                fontWeight: 900,
                color: "#16063b",
              }}
            >
              {translate ? newTitle : news?.title}
            </a>

            <Typography
              style={{
                marginTop: "12px",
                fontFamily: "Overpass",
                fontSize: "14px",
                color: "#808080",
              }}
            >
              {translate ? newContent : news?.content}
            </Typography>

            {isDesktopOrLaptop ? (
              <Typography
                style={{
                  marginTop: "23px",
                  fontSize: "14px",
                  color: "#808080",
                }}
              >
                {news?.publishedAt?.substr(0, 10)}
              </Typography>
            ) : (
              <a href={news?.url} target="_blank">
                <Typography
                  style={{
                    marginTop: "12px",
                    fontFamily: "Overpass",
                    fontSize: "14px",
                    color: "#0040ff",
                    textDecoration: "underline",
                  }}
                >
                  Read More
                </Typography>
              </a>
            )}
          </Grid>
          {isDesktopOrLaptop ? (
            <Grid
              item
              xs={3}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {imageError ? null : (
                <div
                  style={{
                    maxWidth: isDesktopOrLaptop ? "190px" : "150px",
                    maxHeight: isDesktopOrLaptop ? "190px" : "150px",
                    marginRight: "25px",
                    // borderRadius: "20px",
                    // backgroundColor: "#d8d8d8",
                    // display: "flex",
                    // alignItems: "center",
                    // justifyContent: "center",
                  }}
                >
                  <img
                    // width="100%"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      borderRadius: "20px",
                    }}
                    src={news?.urlToImage}
                    onError={(e) => {
                      setImageError(true);
                    }}
                  ></img>
                </div>
              )}
            </Grid>
          ) : null}
        </>
      </div>
    </>
  );
};
